export const errors = (code:number) : string => {
    if (code === 1802) return "Valor minimo nao alcando, por favor realizar uma compra acima de 5 USDTs";
    if (code === 5) return "Uma conta com esse hash já existe";
    if (code === 1) return "Mensagem de assinatura incorreta"
    return '';
}

export const errorsByMessage = (str:string) : string => {
    if (str.includes('hash address signup failed')) return "Uma conta com esse hash já existe";
    return str;
}